import React, { useContext } from 'react';
import { useParams } from 'react-router';

import { useDeps } from 'src/hooks/useDeps';
import { GoogleMap } from 'src/components/GoogleMaps/GoogleMaps';
import { GoogleMapsApiProvider } from 'src/components/GoogleMaps/GoogleMapsApiProvider';
import { TwoUp } from 'src/components/Layout/TwoUp';
import classes from 'src/components/GoogleMaps/styles/BranchView.scss';

import { Spinner } from '../Layout/Spinner';
import { Breadcrumbs } from '../Breadcrumbs/Breadcrumbs';

import { BranchLocationQueryContext, BranchLocationQueryProvider } from './BranchLocationQuery';
import { BranchViewQuery } from './BranchViewQuery';
import { BranchViewContent } from './BranchViewContent';

export const BranchView = React.memo(function BranchView() {
    const { GOOGLE_MAPS_API_KEY } = useDeps().env;

    return (
        <BranchLocationQueryProvider>
            <GoogleMapsApiProvider apiKey={GOOGLE_MAPS_API_KEY} language="en" region="IE">
                <BranchViewInner />
            </GoogleMapsApiProvider>
        </BranchLocationQueryProvider>
    );
});

const BranchViewInner = () => {
    const { id } = useParams() as Record<string, any>;
    const { branches } = useContext(BranchLocationQueryContext);
    const visibleBranches = branches.filter((branch) => branch.id === id);
    const branchDetailName = visibleBranches[0]?.name || 'unknown name';

    return (
        <BranchViewQuery
            name={branchDetailName}
            render={({ loading, detail }) => {
                const branchName = (detail && detail.name) || branchDetailName;
                const branchDetails =
                    !loading && detail ? (
                        <BranchViewContent branches={branches} detail={detail} name={branchName} />
                    ) : (
                        <Spinner />
                    );

                return (
                    <>
                        <Breadcrumbs
                            breadcrumbs={[
                                {
                                    id: '01',
                                    url_key: 'storelocator',
                                    url_path: [],
                                    name: 'Stores',
                                },
                            ]}
                            current={branchName}
                        />
                        <TwoUp
                            left={branchDetails}
                            right={
                                <div className={classes.branchMapPadded}>
                                    <GoogleMap visibleBranches={visibleBranches} />
                                </div>
                            }
                        />
                    </>
                );
            }}
        />
    );
};
